import { useEffect, useRef } from "react";

export const usePrevious = (data) => {
  const ref = useRef(data);
  useEffect(() => {
    ref.current = data;
  }, [data])
  return ref.current;
}

